import { IconWithText } from 'common/icon/icon-with-text.js';
import * as React from 'react';
import { IMapKeyContent } from 'types/location.js';
import { MarineMarkerLocationTypeCustom } from 'types/markerTypes/markers.waterActivityMarine.js';
import { StatusRating } from 'utilities/status/status-rating.js';

const LabelEl = ({ labelClass, label, prefix }: { label: string; labelClass?: string; prefix: string }) => {
  return (
    <small className="fineprint u-textBold u-block u-text-sm">
      <span className="u-mR-xs u-text-xs">{`${prefix} :`}</span>
      <span className={`${labelClass}`}>{label}</span>
    </small>
  );
};

function StatusLegendInner({
  keyContent,
  index,
  prefix,
}: {
  keyContent: IStatusMapKeyContent;
  index: number;
  prefix: string;
}): JSX.Element {
  const { status, label, value, icon } = keyContent;

  return (
    <React.Fragment key={index}>
      <IconWithText
        icon={icon}
        iconClass="svg-fill-font-color u-textSlate"
        classes="IconWithText--small IconWithText--vCenter"
      >
        <LabelEl label={label} labelClass={status} prefix={prefix} />
      </IconWithText>

      {value && <p className="fineprint u-mT-0">{value}</p>}
    </React.Fragment>
  );
}

export type IStatusMapKeyContent = Omit<IMapKeyContent, 'rating'> & { status?: StatusRating };

export interface StatusLegendMapKey {
  content?: IStatusMapKeyContent[];
  prefix: string;
  type: MarineMarkerLocationTypeCustom['type'];
}

/**
 * Build key data based on statusRating info
 * @todo need to add arg
 */
export const StatusLegend = ({ mapKey: { content, prefix } }: { mapKey: StatusLegendMapKey }) => (
  <div data-comp="generic-legend">
    {content?.map((keyContent, index) => (
      <StatusLegendInner key={index} keyContent={keyContent} index={index} prefix={prefix} />
    ))}
  </div>
);
